import { render, staticRenderFns } from "./TradeResponseInfo.vue?vue&type=template&id=1adcb8a0"
import script from "./TradeResponseInfo.vue?vue&type=script&lang=js"
export * from "./TradeResponseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports